/**
 * Precision constants for decimal conversions
 * Critical for trading calculations - all values must be scaled correctly
 */

export const PRECISION_6 = 1000000n; // USDC (6 decimals)
export const PRECISION_18 = 1000000000000000000n; // Prices (18 decimals)

export const DEFAULT_SLIPPAGE_PERCENTAGE = 0.25;

export const MIN_OPEN_SIZE_USD = 5;
export const MIN_COLLATERAL_USD = MIN_OPEN_SIZE_USD;
export const MAX_COLLATERAL_USD = 2_000_000;

export const ORDER_TYPE_MAP: Record<string, number> = {
  'market': 0, // OpenOrderType.MARKET
  'limit': 1,  // OpenOrderType.LIMIT
  'stop': 2,   // OpenOrderType.STOP
};
